import React, { FC, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { ContactForm } from './ContactForm';

export type TimeSlot = {
    from: string,
    to: string
}

type Props = {
    onClose: () => void
}

export const ModalWindow: FC<Props> = ({ onClose }) => {

    return (
        <>
            <Modal show onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Vyplňte Vaše údaje</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <ContactForm />
                </Modal.Body>
            </Modal>
        </>
    );
}